module.exports = __webpack_public_path__ + "static/media/default-logo.ac8d4552.svg";